/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable users
import { tableSchemaBase as columns } from '../users.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IUsersDatatableSlice {
	usersDatatableOptions: TColumnsSchema[];
	setUsersDatatableOptions: (
		_usersDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeUsersDatatableSlice = (
	s: any
): any => ({
	usersDatatableOptions: s.usersDatatableOptions,
});

const initialState = {
	usersDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
};

export const createUsersDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IUsersDatatableSlice
> = (set) => ({
	...initialState,
	setUsersDatatableOptions: (
		_usersDatatableOptions: TColumnsSchema[]
	) =>
		set({
			usersDatatableOptions: _usersDatatableOptions,
		}),
});
